import type {PageRouteConfig} from '@router';

import InvoiceDetails from 'modules/Invoice/InvoiceDetails/InvoiceDetails';

export function createInvoiceDetailsRoute(): PageRouteConfig {
  return {
    element: <InvoiceDetails />,
    layout: {
      title: 'صورت حساب مالی',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
